const LOGGING_ENABLED = false

export const cliLog = (...msgs: any[]) => {
  if (!LOGGING_ENABLED) return
  console.log(...msgs)
}

export const cliWarn = (...msgs: any[]) => {
  if (!LOGGING_ENABLED) return
  console.warn(...msgs)
}
